const sections = document.querySelectorAll('.image-with-text-blocks');

function setPositionHandler(section) {
  const scrollBar = section.querySelector('.swiper-scrollbar');
  const image = section.querySelector('.image-with-text-blocks .image-wrap');
  const prevButton = section.querySelector('.swiper-button-prev');
  const nextButton = section.querySelector('.swiper-button-next');

  if (image) {
    const heightStr = window.getComputedStyle(image).getPropertyValue('height');
    const heightValue = parseFloat(heightStr);
    const finalTop = heightValue + 44;

    if (scrollBar) {
      scrollBar.style.top = `${finalTop}px`;
    }

    if (prevButton && nextButton) {
      prevButton.style.top = `${heightValue / 2 + 40}px`;
      nextButton.style.top = `${heightValue / 2 + 40}px`;
    }
  }
}


sections.forEach(sectionItem => {
  const swiperElement = sectionItem.querySelector('.image-with-text-blocks-swiper');
  if (swiperElement) {

    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 500,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })
  }

});

let swiperTimeout = null;
window.addEventListener('resize', () => {
  clearTimeout(swiperTimeout);

  swiperTimeout = setTimeout(() => {
    sections.forEach(sectionItem => {
      setPositionHandler(sectionItem);
    });
  }, 300);
});

document.addEventListener('DOMContentLoaded', () => {
  sections.forEach(sectionItem => {
    setPositionHandler(sectionItem);
  });
})
window.addEventListener('orientationchange', () => {
  sections.forEach(sectionItem => {
    setPositionHandler(sectionItem);
  });
});
